module.exports = __webpack_public_path__ + "static/mask-cage3-768a73e17433feab1c1df6a4bda008e6.jpg";